<template>
  <RouterLink :to="to" class="card">
    <div class="card-head">
      <p class="card-head__title">{{ title }}</p>
      <img src="@/assets/img/link.svg" alt="" class="card-head__icon">
    </div>
    <p class="card__text">{{ description }}</p>
  </RouterLink>
</template>

<script>
export default {
  name: "DiaryCard",
  props: {
    created_at: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    time: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    user_id: {
      type: String,
      required: true,
    },
  },
  computed: {
    to() {
      return { name: "noteIdPage", params: { id: this.id } };
    }
  }
}
</script>

<style scoped>


.card{
  max-width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 242px;
  border: 1px solid #F7AD3D;
  border-radius: 10px;
  padding: 24px;
  max-width: 100%;
  width: 100%;
  background: #fff;
}
.card-head{
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}
.card-head__icon{
  display: flex;
  flex-shrink: 0;
}
.card-head__title{
  font-weight: 500;
  font-size: 20px;
  line-height: 100%;
  color: #100c40;
}
.card__text{
  margin-top: auto;
font-weight: 400;
font-size: 16px;
line-height: 100%;
color: rgba(16, 12, 64, 0.2);
}

</style>
